/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f637bf95186c227529956ad4df65712>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "OnCall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing on-call across Atlassian apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const OnCallIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "OnCallIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="m4.25 2 .123.01a.75.75 0 0 1 .598.534l.821 2.874a1.75 1.75 0 0 1-.563 1.825L3.291 8.857a12.3 12.3 0 0 0 3.85 3.851l1.616-1.937a1.75 1.75 0 0 1 1.825-.563l2.874.821a.75.75 0 0 1 .544.721v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 0 2.75.75.75 0 0 1 .75 2zm5.92 9.65a.25.25 0 0 0-.26.08l-1.426 1.708c1.25.579 2.605.941 4.016 1.037v-2.16zM1.525 3.5c.096 1.41.458 2.765 1.036 4.015L4.27 6.09a.25.25 0 0 0 .08-.26L3.685 3.5z"/><path fill="currentcolor" d="M10 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m2.5-2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M15 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
OnCallIcon.displayName = 'OnCallIcon';
var _default = exports.default = OnCallIcon;